import { Routes } from '@angular/router';
import { GESTAO_CONCURSO_OVERVIEWS } from './gestao-concurso-overviews';

const overview = () =>
  import('./shared/module-overview/module-overview.component').then(
    (module) => module.ModuleOverviewComponent,
  );

export const concursoRoutes: Routes = [
  {
    path: 'entidades',
    loadComponent: () =>
      import('./entidades/lista-entidades/lista-entidades.component').then(
        (module) => module.ListaEntidadesComponent,
      ),
  },
  {
    path: 'concurso',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./concurso/components/home-concursos/home-concursos.component').then(
            (module) => module.HomeConcursosComponent,
          ),
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./concurso/components/novo-concurso/novo-concurso.component').then(
            (module) => module.NovoConcursoComponent,
          ),
      },
      {
        path: ':id/configurar',
        loadComponent: () =>
          import('./concurso/components/configurar-concurso/configurar-concurso.component').then(
            (module) => module.ConfigurarConcursoComponent,
          ),
      },
      { path: ':id/editar', redirectTo: ':id/configurar' },
      {
        path: ':id/duplicar',
        loadComponent: () =>
          import('./concurso/components/cadastrar-concurso/cadastrar-concurso.component').then(
            (module) => module.CadastrarConcursoComponent,
          ),
      },
      // O detalhe passou para o ecrã de configuração por secções.
      {
        path: ':id',
        redirectTo: (route) =>
          route.params['id']
            ? `/gestao-concurso/concurso/${route.params['id']}/configurar`
            : '/gestao-concurso/concurso',
      },
    ],
  },
  {
    path: 'workflow',
    loadComponent: () =>
      import('./workflow/motor-workflow/motor-workflow.component').then(
        (module) => module.MotorWorkflowComponent,
      ),
  },
  {
    path: 'candidaturas',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./candidaturas/home-candidaturas/home-candidaturas.component').then(
            (module) => module.HomeCandidaturasComponent,
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./candidaturas/detalhe-candidatura/detalhe-candidatura.component').then(
            (module) => module.DetalheCandidaturaComponent,
          ),
      },
    ],
  },
  {
    path: 'candidatos',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./candidatos/lista-candidatos/lista-candidatos.component').then(
            (module) => module.ListaCandidatosComponent,
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./candidatos/detalhe-candidato/detalhe-candidato.component').then(
            (module) => module.DetalheCandidatoComponent,
          ),
      },
    ],
  },
  {
    path: 'comissoes',
    loadComponent: () =>
      import('./comissoes/lista-comissoes/lista-comissoes.component').then(
        (module) => module.ListaComissoesComponent,
      ),
  },
  {
    path: 'provas/nova',
    loadComponent: () =>
      import('./provas/criar-prova/criar-prova.component').then(
        (module) => module.CriarProvaComponent,
      ),
  },
  {
    path: 'provas/lote',
    loadComponent: () =>
      import('./provas/questoes-lote/questoes-lote.component').then(
        (module) => module.QuestoesLoteComponent,
      ),
  },
  {
    path: 'provas/minhas-provas',
    loadComponent: () =>
      import('./provas/minhas-provas/minhas-provas.component').then(
        (module) => module.MinhasProvasComponent,
      ),
  },
  {
    path: 'provas/sala-exame/:convocacaoId',
    loadComponent: () =>
      import('./provas/sala-exame/sala-exame.component').then(
        (module) => module.SalaExameComponent,
      ),
  },
  {
    path: 'provas',
    loadComponent: () =>
      import('./provas/provas.component').then(
        (module) => module.ProvasComponent,
      ),
  },
  {
    path: 'provas/banco-perguntas',
    redirectTo: 'provas',
  },
  {
    path: 'apuramento',
    loadComponent: () =>
      import('./apuramento/ranking-apuramento/ranking-apuramento.component').then(
        (module) => module.RankingApuramentoComponent,
      ),
  },
  {
    path: 'reclamacoes',
    loadComponent: () =>
      import('./reclamacoes/lista-reclamacoes/lista-reclamacoes.component').then(
        (module) => module.ListaReclamacoesComponent,
      ),
  },
  {
    path: 'auditoria',
    loadComponent: overview,
    data: GESTAO_CONCURSO_OVERVIEWS['auditoria'],
  },
  {
    path: 'catalogos',
    loadComponent: overview,
    data: GESTAO_CONCURSO_OVERVIEWS['catalogos'],
  },
  { path: '', pathMatch: 'full', redirectTo: 'concurso' },
];
